import callApi from '../../util/apiCaller';

export const REQUEST_FEEDBACK_SHOW_SUMMARY_WINDOW = 'REQUEST_FEEDBACK_SHOW_SUMMARY_WINDOW';
export const REQUEST_FEEDBACK_HIDE_SUMMARY_WINDOW = 'REQUEST_FEEDBACK_HIDE_SUMMARY_WINDOW';
export const REQUEST_FEEDBACK_SHOW_OBJECT = 'REQUEST_FEEDBACK_SHOW_OBJECT';
export const REQUEST_FEEDBACK_LOAD_SURVEYS = 'REQUEST_FEEDBACK_LOAD_SURVEYS';


export function closeSummaryWindow() {
  return (dispatch) => {
    return dispatch({
      type: REQUEST_FEEDBACK_HIDE_SUMMARY_WINDOW,
    });
  };
}
export function showSummaryWindow() {
  return (dispatch) => {
    return dispatch({
      type: REQUEST_FEEDBACK_SHOW_SUMMARY_WINDOW,
    });
  };
}


export function showRequestFeedbackWindowForObject(object, isAccount = false) {
  return (dispatch) => {
    dispatch({
      type: REQUEST_FEEDBACK_SHOW_OBJECT, object, isAccount,
    });
    showSummaryWindow()(dispatch);
  };
}

export function loadSurveys(object, isAccount = false) {
  return (dispatch) => {
    const id = isAccount ? object.account_id : object.opportunity_id;
    dispatch({
      type: REQUEST_FEEDBACK_LOAD_SURVEYS, id, items: [], loading: true, loaded: false, error: null,
    });
    const p = callApi(`dashboard/win-loss/${(isAccount ? 'accounts' : 'opportunities')}/${id}/surveys`, 'GET');
    p.then(
      (results) => {
        return dispatch({
          type: REQUEST_FEEDBACK_LOAD_SURVEYS, id, items: results.surveys, loaded: true, loading: false, error: null,
        });
      },
      (error) => {
        return dispatch({
          type: REQUEST_FEEDBACK_LOAD_SURVEYS, id, items: [], loaded: false, loading: false, error,
        });
      },
    );
    return p;
  };
}
